export interface TreeClass {
  chidren: TreeClass[];
  code: string;
  label: string;
  numberOfProducts: number;
  parentCode: string;
}
